<template>
  <div class="card">
    <div class="border-0 card-header">
      <h3 class="mb-0">Users</h3>
    </div>

    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      :data="queriedData"
    >
      <el-table-column
        label="UserName"
        prop="username"
        min-width="140px"
        sortable
      >
      </el-table-column>
      <el-table-column label="Name" prop="name" min-width="140px" sortable>
      </el-table-column>

      <el-table-column label="Email" prop="email" min-width="170px" sortable>
      </el-table-column>

      <el-table-column
        label="Created On"
        prop="created_at"
        min-width="170px"
        sortable
      >
      </el-table-column>
      <el-table-column label="" min-width="100px">
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <a
              href="#!"
              @click.prevent="editUser(row)"
              class="table-action table-action-edit"
              data-toggle="tooltip"
              data-original-title="Edit"
            >
              <i class="fas fa-user-edit"></i>
            </a>

            &nbsp;&nbsp;

            <a
              href="#!"
              @click="prompt(row)"
              class="table-action table-action-delete"
              data-toggle="tooltip"
              data-original-title="Delete"
            >
              <i class="fas fa-trash-alt"></i>
            </a>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer py-4 d-flex justify-content-end">
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
    <modal :show.sync="modals.classic">
      <h6 slot="header" class="modal-title">Delete?</h6>

      <p>Delete user {{ user.name }} ({{ user.email }})?</p>

      <template slot="footer">
        <base-button type="danger" @click="deleteUser(user.id)"
          >Ok, delete</base-button
        >
        <base-button type="link" class="ml-auto" @click="modals.classic = false"
          >Cancel</base-button
        >
      </template>
    </modal>
  </div>
</template>
<script>
import store from "@/store";
import { mapState } from "vuex";
import { Table, TableColumn } from "element-ui";
import { Modal, BasePagination } from "@/components";
import clientPaginationMixin from "./clientPaginationMixin";

let getUserList = function() {
  return store.dispatch("user/list");
};

export default {
  name: "UserList",
  mixins: [clientPaginationMixin],
  data() {
    return {
      tableData: [],
      user: {},
      modals: {
        classic: false
      }
    };
  },
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    Modal
  },
  created() {
    // fetch users from api server
    getUserList().then(() => {
      this.tableData = store.state.user.users;
    });
  },
  methods: {
    prompt(user) {
      this.modals.classic = true;
      this.user = user;
    },
    editUser(row) {
      // show user's details in form
      store.dispatch("user/edit", row);
    },
    deleteUser(id) {
      store.dispatch("user/delete", { id }).then(() => {
        getUserList().then(() => {
          this.tableData = store.state.user.users;
          this.modals.classic = false;
        });
      });
    }
  }
};
</script>
